export default __webpack_public_path__ + "static/media/video-image-1.0d8a0e25.png";